import '../Sass/App.scss';
import React, { useState, useRef } from 'react';
import { useDrop } from 'react-dnd'
import { Hand } from './Hand';
import { VirusIntegrity } from './VirusIntegrity';
import { VirusCardGroup } from './VirusCardGroup';

let CARD_WIDTH = 550

export function Virus(props) {

    const cardHeight = CARD_WIDTH * 0.22
    const [hand, setHand] = useState([])
    const [shown, setShown] = useState(true)

    const [{ isOver }, dropRef] = useDrop({
        accept: ['dev-card', 'ml-card'],
        drop: (item) => {
            const dragIndex = item.indexInSeries
            item.sendHandler(dragIndex, 1)
            addToHand(item.cardData, 0)
        },
        collect: (monitor) => ({
            isOver: monitor.isOver()
        })
    })

    function addToHand(card, position) {
        const currentHand = [...hand]
        setHand([
            ...currentHand.slice(0,position+1),
            card,
            ...currentHand.slice(position+1, currentHand.length)
        ])
    }

    function getCardStyle(isOver) {
        switch (props.cardStyle) {
            default: 
                return {width: CARD_WIDTH, height: cardHeight};
        }
    }

    function discardVirus() {
        setShown(false)
    }

    return (
        <div style={shown || props.showDestroyed ? null : {display: 'none'}}>
            <Hand currentHome={'virus_' + props.virus.name + '_cards'} cards={hand} cardWidth={150} clickHandler={props.clickHandler} setCards={setHand} handType='virus' />
            <div className="virus-holder" style={{width: CARD_WIDTH, marginBottom: 15 + (CARD_WIDTH / 10.5 * -1)}}>
                <div className="virus-scalable" ref={dropRef} style={getCardStyle(isOver)}>
                    <VirusIntegrity maxIntegrity={parseInt(props.virus.max_integrity)} currentIntegrity={parseInt(props.virus.max_integrity)} cardWidth={CARD_WIDTH} />
                    <div className='virus-info-wrapper'>
                        <div className='virus-name' style={{fontSize: CARD_WIDTH / 30}}>{props.virus.name}</div>
                        <div className='virus-init' style={{fontSize: CARD_WIDTH / 50}}>{props.virus.init}</div>
                    </div>
                    <div className='virus-card-label' style={{left: '7%', fontSize: CARD_WIDTH / 60}}></div>
                    <div className='virus-card-label' style={{left: '10%', fontSize: CARD_WIDTH / 60}}></div>
                    <div className='virus-card-label-text' style={{left: '43%', fontSize: CARD_WIDTH / 60}}>listeners</div>
                    <div className='virus-card-label-text' style={{left: '76%', fontSize: CARD_WIDTH / 60}}>functions</div>
                    <button className="close-button" style={{left: '-15px', bottom: '-15px'}} onClick={discardVirus}>X</button>
                </div>
                <div className='virus-card-bank' style={{left: '32%', top: CARD_WIDTH / 9.5 * -1}}>
                    <VirusCardGroup cards={props.virus.viral_listeners} currentHome={'virus_' + props.virus.name + '_group_listeners'} clickHandler={props.clickHandler} cardWidth={CARD_WIDTH} />
                </div>
                <div className='virus-card-bank' style={{left: '36%', top: CARD_WIDTH / 9.5 * -1}}>
                    <VirusCardGroup cards={props.virus.viral_functions} currentHome={'virus_' + props.virus.name + '_group_functions'} clickHandler={props.clickHandler} cardWidth={CARD_WIDTH} />
                </div>
            </div>
        </div>
    )
}
